import React, {ReactNode} from 'react';

export const renderTooltipCell = (text: string, tooltip?: string): ReactNode =>
    <span title={tooltip}>{text}</span>;
